// extracted by mini-css-extract-plugin
export var buttonWrapperStyle = "chapter_prev_next_buttons-module--buttonWrapperStyle--2S-BL";